import React from 'react';

import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives/responsive';
import UFOSegment from '@atlaskit/react-ufo/segment';
import { token } from '@atlaskit/tokens';

import { wacToken } from '@/libraries/design/foundations';
import { useDarkTheme } from '@/libraries/design/utils/dark-theme-provider';

import { GlobalFooterBottom } from './global-footer-bottom';
import { GlobalFooterTop } from './global-footer-top';

const globalFooterStyle = css({
	alignItems: 'center',
	background: wacToken('color.neutral.light0'),
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
});

const globalFooterDarkThemeStyle = css({
	background: wacToken('color.neutral.dark100'),
});

const globalFooterContentContainerStyle = css({
	backgroundColor: wacToken('color.neutral.light0'),
	paddingBlock: token('space.200'),
	display: 'flex',
	flexDirection: 'column',
	gap: token('space.200'),
	width: '100%',
	marginInline: '24px',

	[media.above.md]: {
		display: 'flex',
		maxWidth: '1200px',
		paddingInline: '0',
		marginInline: '60px',
	},
});

const globalFooterContentContainerDarkThemeStyle = css({
	backgroundColor: 'transparent',
});

export type GlobalFooterPatternProps = {
	selectedLanguage?: string;
	onLanguageChangeHandler?: React.Dispatch<string>;
};

export const GlobalFooter = ({
	selectedLanguage,
	onLanguageChangeHandler,
}: GlobalFooterPatternProps) => {
	const { isDarkTheme } = useDarkTheme();

	return (
		<UFOSegment name="global-footer-v2">
			<footer css={[globalFooterStyle, isDarkTheme && globalFooterDarkThemeStyle]}>
				<div
					css={[
						globalFooterContentContainerStyle,
						isDarkTheme && globalFooterContentContainerDarkThemeStyle,
					]}
				>
					<GlobalFooterTop />
					<GlobalFooterBottom
						selectedLanguage={selectedLanguage}
						onLanguageChangeHandler={onLanguageChangeHandler}
					/>
				</div>
			</footer>
		</UFOSegment>
	);
};
